import * as React from 'react';
import { useState } from 'react';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Address,
  ProxyNetworkProvider,
  Transaction
} from '@multiversx/sdk-core/out';
import { Button } from 'react-bootstrap';
import { GAS_PRICE, signAndSendTransactions } from 'helpers';
import {
  useGetAccount,
  useGetNetworkConfig,
  useGetPendingTransactions
} from 'hooks';

export const Actions = (datas: any) => {
  console.log(datas.datas);
  const hasPendingTransactions = useGetPendingTransactions().length > 0;
  const { address } = useGetAccount();
  const { network } = useGetNetworkConfig();
  const [, setTransactionSessionId] = useState<string | null>(null);

  const sendEsdtTransaction = async () => {
    const receiver = new Address(
      'erd1qqqqqqqqqqqqqqqpqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqzllls8a5w6u'
    );

    const pingTransaction = new Transaction({
      value: BigInt('50000000000000000'),
      data: Buffer.from(datas.datas),
      receiver,
      gasLimit: BigInt(60000000),
      gasPrice: BigInt(GAS_PRICE),
      chainID: network.chainId,
      sender: new Address(address),
      version: 2
    });

    const networkProvider = new ProxyNetworkProvider(network.apiAddress);
    const account = await networkProvider.getAccount(new Address(address));
    pingTransaction.nonce = account.nonce;

    const sessionId = await signAndSendTransactions({
      transactions: [pingTransaction],
      transactionsDisplayInfo: {
        processingMessage: 'Processing Issue transaction',
        errorMessage: 'An error has occured during Issue',
        successMessage: 'Issue transaction successful'
      }
    });
    if (sessionId != null) {
      setTransactionSessionId(sessionId);
    }
  };

  return (
    <div className=''>
      {!hasPendingTransactions && (
        <div
          onClick={sendEsdtTransaction}
          data-testid='btnPing'
          data-cy='transactionBtn'
        >
          <Button variant='primary'>
            submit tx on devnet2 network{' '}
            <FontAwesomeIcon icon={faArrowUp} className='text-primary' />
          </Button>
        </div>
      )}
    </div>
  );
};
